//MEMO(minami) 引数にエラー集と実際のエラーを指定することで、エラー集から実際のエラーとマッチするエラーを探し、そのエラーの文言を返します
export const findError = (errors: { [key in string]: string }, error: string) => {
  const errorFind = Object.keys(errors).find((item) => item === error);
  const errorValue = !!errorFind && Object.getOwnPropertyDescriptor(errors, errorFind);

  return !!errorValue ? errorValue.value : null;
};
